import { Zap, Dumbbell, Leaf, HeartPulse } from "lucide-react";
import { BENEFITS } from "@/lib/content";
import { useReveal } from "@/lib/useReveal";

const ICONS = { Zap, Dumbbell, Leaf, HeartPulse };

export const Benefits = () => {
  const { ref, inView } = useReveal();
  return (
    <section className="bg-white py-12 sm:py-16 lg:py-20" ref={ref}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className={`mb-10 text-center hp-reveal ${inView ? "in-view" : ""}`}>
          <h2 className="font-display text-3xl uppercase text-neutral-900 sm:text-4xl">Key Benefits</h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-neutral-600">
            Horse Power Capsule is crafted with traditional Ayurvedic herbs that help support
            your daily energy and wellness.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map((b, i) => {
            const Icon = ICONS[b.icon];
            return (
              <div
                key={b.title}
                data-testid={`benefit-card-${i}`}
                className={`rounded-2xl border border-neutral-200 bg-[var(--hp-page)] p-6 hp-reveal ${
                  inView ? "in-view" : ""
                }`}
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--hp-crimson)] text-white">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-4 text-lg font-bold text-neutral-900">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-600">{b.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
